import '../styles/logo.scss';
import React, { useState, useEffect } from 'react';
import { logos } from '../services/data.ts';

export const Logo = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (

    <div
      id="logo"
      onClick={scrollToTop}
      role="button"
      aria-label="Return to top"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          scrollToTop();
        }
      }}
    >
      <img src={logos.arrow_up} id={isScrolled ? 'up' : 'none'} />
      <img src={logos.mini} id="mini" />
    </div>



  );
};

export const LogoMini = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <div id="logo-mini" onClick={scrollToTop}>
      <img src={logos.mini} height={20}/>
    </div>
  )
}